const STEPS = [
  {
    step: "Step One",
    title: "Call or Submit Photos",
    desc: "Call (321) 420-2707 or send your details online. We provide a fast, honest estimate based on volume.",
    border: "border-white",
  },
  {
    step: "Step Two",
    title: "On-Time Crew Arrival",
    desc: "Our Brevard crew arrives in our branded rig during the scheduled window and confirms the final upfront price.",
    border: "border-white/40",
  },
  {
    step: "Step Three",
    title: "Loaded & Swept Clean",
    desc: "We lift, load, strap down, and sweep the area spotless. You inspect the empty space before payment.",
    border: "border-white/20",
  },
];

export default function Process() {
  return (
    <section id="pricing-guide" data-testid="process-section" className="py-24 bg-zinc-950 border-t border-white/10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
            Simple 3-Step Clearance
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base mt-2">
            From quote to finished haul in three clear stages without hidden dump fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((s) => (
            <div key={s.step} className={`border-t-2 ${s.border} pt-6 space-y-3`}>
              <div className="text-xs font-mono text-zinc-300 uppercase tracking-widest">{s.step}</div>
              <h3 className="text-xl font-bold uppercase text-white">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
